module.exports = __webpack_public_path__ + "static/media/chair2.04abf0e3.png";